import {
  AddExaminerDocumentPayload,
  api,
  DeleteExaminerDocumentParams,
  DownloadExaminerDocumentParams,
  ExaminerDocument,
  ExaminerDocumentType,
  FileUrl,
  PagedResultOfExaminerDocument,
} from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';
import { TableState } from 'types';
import { getPaginationParameters, getQueryStringParameters } from 'utils';

type DocumentListQueryParams = TableState<ExaminerDocument, undefined> & {
  examinerId: number;
  documentTypes: ExaminerDocumentType[];
};

export const documentsApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getExaminerDocuments: builder.query<PagedResultOfExaminerDocument, DocumentListQueryParams>({
      query: (params) => {
        const input = getQueryStringParameters({
          ...getPaginationParameters(params),
          filter: {
            examinerId: params.examinerId,
            documentTypes: params.documentTypes,
          },
        });
        return api.examinerDocument.getExaminerDocuments(input);
      },
      providesTags: ['Documents'],
    }),
    addExaminerDocument: builder.mutation<void, AddExaminerDocumentPayload>({
      query: (data) => api.examinerDocument.addExaminerDocument(data),
      invalidatesTags: ['Documents'],
    }),
    deleteExaminerDocument: builder.mutation<void, DeleteExaminerDocumentParams>({
      query: (query) => api.examinerDocument.deleteExaminerDocument(query),
      invalidatesTags: ['Documents'],
    }),
    downloadExaminerDocument: builder.query<FileUrl, DownloadExaminerDocumentParams>({
      query: (query) => api.examinerDocument.downloadExaminerDocument(query),
    }),
  }),
});

export const {
  useGetExaminerDocumentsQuery,
  useAddExaminerDocumentMutation,
  useDeleteExaminerDocumentMutation,
  useLazyDownloadExaminerDocumentQuery,
} = documentsApi;
